var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36364 2.35689C4.36364 1.55356 5.01486 0.902338 5.81819 0.902344L14.5455 0.902408C15.3488 0.902411 16 1.55363 16 2.35695V11.0841C16 11.8875 15.3488 12.5387 14.5455 12.5387H13.8182C13.4165 12.5387 13.0909 12.2131 13.0909 11.8114V6.3569C13.0909 4.95109 11.9513 3.81145 10.5455 3.81145H5.09091C4.68924 3.81145 4.36364 3.48585 4.36364 3.08418V2.35689ZM0 6.72063C0 5.91731 0.651222 5.26609 1.45455 5.26609L10.1818 5.2661C10.9852 5.2661 11.6364 5.91732 11.6364 6.72064V15.4478C11.6364 16.2511 10.9852 16.9023 10.1818 16.9023H1.45455C0.651222 16.9023 0 16.2511 0 15.4478V6.72063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.5b22e74a364da1afd80ed4f3ea5122d5.svg";
export { ForwardRef as ReactComponent };